export const LOADER_NODE_LIST = {
  '1': { name: '1', depth: 0, children: ['1~~/~~2', '1~~/~~3'] },
  '4': { name: '4', depth: 0, children: ['4~~/~~15'] },
  '6': { name: '6', depth: 0, children: ['6~~/~~7'] },
  '8': { name: '8', depth: 0, children: ['8~~/~~9'] },
  root: { children: ['1', '4', '6', '8'] },
  '1~~/~~2': { name: '2', depth: 1 },
  '1~~/~~3': { name: '3', depth: 1 },
  '4~~/~~15': { name: '15', depth: 1, children: ['4~~/~~15~~/~~5'] },
  '4~~/~~15~~/~~5': { name: '5', depth: 2 },
  '6~~/~~7': { name: '7', depth: 1 },
  '8~~/~~9': {
    name: '9',
    depth: 1,
    children: ['8~~/~~9~~/~~10', '8~~/~~9~~/~~11', '8~~/~~9~~/~~12', '8~~/~~9~~/~~13']
  },
  '8~~/~~9~~/~~10': { name: '10', depth: 2 },
  '8~~/~~9~~/~~11': { name: '11', depth: 2 },
  '8~~/~~9~~/~~12': { name: '12', depth: 2 },
  '8~~/~~9~~/~~13': { name: '13', depth: 2 }
}
